import {getSelectedDeliveryCountry, getSettings} from '../../../../selectors/selectors';
import store from '../../../../store/store';

export default function isAddresseeInvalid(value) {
  const state = store.getState();
  const settings = getSettings(state);
  const surnameIsRequiredForCountries = settings?.countries_to_require_fullname;
  const surnameIsRequiredForThisCountry = surnameIsRequiredForCountries?.includes(getSelectedDeliveryCountry(state));
  
  if (surnameIsRequiredForThisCountry) {
    const containsSpaceRegex = /\s/;
    const trimmedFullnameValue = value.trim();
    const fullnameContainsSpace = containsSpaceRegex.test(trimmedFullnameValue);
  
    // scenario: contains space, no error required
    if (fullnameContainsSpace) return false;
  
    // scenario: no space, fails validation here, throw error
    return 'checkout.delivery.address.field.label.name.text.error.noSurnameProvided';
  }
  
  // scenario: no space and not required so no error.
  return false;
}
